import React from "react";
import "../css/Skeleton.css";

// Bloque base con efecto shimmer. Reserva espacio para evitar layout shift.
export function SkeletonBox({
  width = "100%",
  height = "1rem",
  radius = "8px",
  style = {},
  className = "",
}) {
  return (
    <span
      className={`sk-box ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}

// Cabecera de marcador — mismo footprint que .cuadro-verde para que no salte.
export function SkeletonScore() {
  return (
    <div className="sk-score" aria-hidden="true">
      <div className="sk-score-row">
        <div className="sk-score-team">
          <SkeletonBox className="sk-on-green" width="56px" height="56px" radius="50%" />
          <SkeletonBox className="sk-on-green" width="26px" height="42px" radius="6px" />
        </div>
        <SkeletonBox className="sk-on-green" width="34px" height="26px" radius="6px" />
        <div className="sk-score-team">
          <SkeletonBox className="sk-on-green" width="26px" height="42px" radius="6px" />
          <SkeletonBox className="sk-on-green" width="56px" height="56px" radius="50%" />
        </div>
      </div>
      <SkeletonBox className="sk-on-green" width="58%" height="13px" radius="6px" style={{ margin: "16px auto 0" }} />
      <SkeletonBox className="sk-on-green" width="44%" height="13px" radius="6px" style={{ margin: "11px auto 0" }} />
    </div>
  );
}

// Cancha vertical con 11 jugadores en posiciones 4-4-2 aproximadas.
export function SkeletonCancha() {
  return (
    <div className="sk-cancha" aria-hidden="true">
      <div className="sk-cancha-lines" />
      {Array.from({ length: 11 }).map((_, i) => (
        <span key={i} className="sk-player" />
      ))}
    </div>
  );
}

// Fila de logos de auspiciantes (cuadrados).
export function SkeletonRow({ count = 6 }) {
  return (
    <div className="sk-row" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonBox key={i} className="sk-row-item" width="10rem" height="10rem" radius="1rem" />
      ))}
    </div>
  );
}

// Banner premium — misma altura que el real (180px / 140px mobile).
export function SkeletonBanner() {
  return <div className="sk-banner" aria-hidden="true" />;
}

const Skeletons = { SkeletonBox, SkeletonScore, SkeletonCancha, SkeletonRow, SkeletonBanner };
export default Skeletons;
